export const MIN_ITEM_WIDTH = 20;
export const ITEM_LANE_HEIGHT = 68;
export const ITEM_LANE_HEIGHT_COMPACT = 40;
export const ITEM_HEIGHT = 48;
export const ITEM_HEIGHT_COMPACT = 30;
export const ITEM_HEIGHT_WITH_LABELS = 64;
export const ITEM_TOOLTIP_DELAY = 600;
export const STALE_TIME_MS = 60 * 60 * 1000;
